import { Canvas } from '@react-three/fiber';
import { Suspense } from 'react';
import { NoToneMapping } from 'three';
import { Experience } from './Experience';
import { useAreaConfig, useAreaLandingParams } from '@/hooks';
import { AccessDenied, Loader, NotFound, ServerError } from '../Common';

export const AreaLanding = () => {
  const { areaSlug } = useAreaLandingParams();
  const { data: areaConfig, error } = useAreaConfig(areaSlug);

  if (error) {
    switch (error.data?.code) {
      case 'FORBIDDEN':
        return <AccessDenied error={error.data.accessError as any} />;
      case 'NOT_FOUND':
        return (
          <NotFound
            message={
              'The area you were trying to view could not be found. Please check the link provided.'
            }
          />
        );
      default:
        return <ServerError />;
    }
  }

  return (
    <Canvas
      gl={{
        precision: 'highp',
        toneMapping: NoToneMapping,
        autoClear: false
      }}
      dpr={window.devicePixelRatio}
    >
    {areaConfig?.landingDemo ? (
      <Suspense fallback={<Loader />}>
        <Experience areaConfig={areaConfig} />
      </Suspense>
    ) : (
      <Loader />
    )}
    </Canvas>
  );
};
